// DS: I32
// from Phrac T36082
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const CloseBold: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="0" height="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="evenodd">
        <path d="M4 6.182L6.182 4 20 17.818 17.818 20z" />
        <path d="M20 6.182L6.182 20 4 17.818 17.818 4z" />
      </g>
    </svg>
  </IconWrap>
);
CloseBold.displayName = 'CloseBold';

export default CloseBold;
